"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverloadAbilityHandler = exports.OverloadActorAbilityFactory = exports.OverloadAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
class OverloadAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Overload;
        this.__typeName = "Overload";
    }
}
exports.OverloadAbilityArgs = OverloadAbilityArgs;
let OverloadActorAbilityFactory = class OverloadActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Overload", "Self", 4);
    }
};
OverloadActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Overload")
], OverloadActorAbilityFactory);
exports.OverloadActorAbilityFactory = OverloadActorAbilityFactory;
let OverloadAbilityHandler = class OverloadAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated(sequence) {
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Haste, 15),
                });
            }
        });
    }
};
OverloadAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Overload)
], OverloadAbilityHandler);
exports.OverloadAbilityHandler = OverloadAbilityHandler;
